import React from 'react';
import TextTypeInput from '../common/TextTypeInput.react';

export default class TextInput extends React.Component {
  render() {
    return <TextTypeInput {...this.props} textElementTagName='input' />;
  }
}
